module.exports = __webpack_public_path__ + "img/Ktirio-Aspropirgos.4cd89393.jpg";